import { render, staticRenderFns } from "./button-field.vue?vue&type=template&id=2034acee&scoped=true&"
import script from "./button-field.vue?vue&type=script&lang=js&"
export * from "./button-field.vue?vue&type=script&lang=js&"
import style0 from "./button-field.vue?vue&type=style&index=0&id=2034acee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2034acee",
  null
  
)

export default component.exports